import React from 'react';
import './styles.css';
import { Button, Grid } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { useT } from '../../i18n';

function School({ school }) {
    const navigate = useNavigate();
    const { t } = useT();
    const { name, description, image } = school;
    const handleClick = () => {
        navigate('/donate/' + school.id);
    };
    return (
        <div>
            <Grid columns={3} gap={8}>
                <Grid.Item span={3}>
                    <div className="card">
                        <div className="image__container">
                            <img src={image} alt={name} />
                        </div>
                        <p className="center m-0">{name}</p>
                        <p>{description}</p>
                        <Button size="middle" className="primary" onClick={handleClick}>
                            {t('donate_button')}
                        </Button>
                    </div>
                </Grid.Item>
            </Grid>
        </div>
    );
}

export default School;
